/**
 * Placeholder taxpayer data. Replace with the registry API responses; the list
 * is one page's worth of rows, the detail object one taxpayer's 360° record.
 */

// Reported by the API alongside each page of rows.
export const TOTAL_TAXPAYERS = 3200000;

export const TAXPAYERS = [
  {
    nif: "100-123-456",
    name: "Blue Horizon Ltd.",
    type: "Company",
    status: "Active",
    risk: "Low",
    score: 87,
    industry: "Manufacturing",
    province: "Luanda",
    updatedDate: "01 Sep 2026",
    updatedTime: "10:45 AM",
  },
  {
    nif: "200-234-567",
    name: "Alpha Traders Ltd.",
    type: "Company",
    status: "Active",
    risk: "High",
    score: 38,
    industry: "Trading",
    province: "Luanda",
    updatedDate: "01 Sep 2026",
    updatedTime: "09:32 AM",
  },
  {
    nif: "300-345-678",
    name: "Prime Logistics SARL",
    type: "Company",
    status: "Active",
    risk: "Medium",
    score: 72,
    industry: "Logistics",
    province: "Bengo",
    updatedDate: "01 Sep 2026",
    updatedTime: "09:15 AM",
  },
  {
    nif: "100-456-789",
    name: "ABC Trading Ltd.",
    type: "Company",
    status: "Active",
    risk: "Medium",
    score: 65,
    industry: "Trading",
    province: "Luanda",
    updatedDate: "01 Sep 2026",
    updatedTime: "08:32 AM",
  },
  {
    nif: "400-567-890",
    name: "Delta Services Ltd.",
    type: "Company",
    status: "Active",
    risk: "Low",
    score: 91,
    industry: "Services",
    province: "Huila",
    updatedDate: "01 Sep 2026",
    updatedTime: "08:10 AM",
  },
  {
    nif: "500-678-901",
    name: "Greenfield Imports",
    type: "Company",
    status: "Inactive",
    risk: "High",
    score: 28,
    industry: "Import/Export",
    province: "Cabinda",
    updatedDate: "01 Sep 2026",
    updatedTime: "07:45 AM",
  },
  {
    nif: "600-789-012",
    name: "Sunrise Construction",
    type: "Company",
    status: "Active",
    risk: "Medium",
    score: 71,
    industry: "Construction",
    province: "Luanda",
    updatedDate: "01 Sep 2026",
    updatedTime: "07:20 AM",
  },
  {
    nif: "700-890-123",
    name: "AngoTech Solutions",
    type: "Company",
    status: "Active",
    risk: "Low",
    score: 93,
    industry: "Technology",
    province: "Luanda",
    updatedDate: "01 Sep 2026",
    updatedTime: "07:05 AM",
  },
  {
    nif: "800-901-234",
    name: "Global Foods Ltd.",
    type: "Company",
    status: "Active",
    risk: "Medium",
    score: 62,
    industry: "Food & Beverages",
    province: "Bengo",
    updatedDate: "01 Sep 2026",
    updatedTime: "06:50 AM",
  },
  {
    nif: "900-012-345",
    name: "PetroMax Services",
    type: "Company",
    status: "Inactive",
    risk: "High",
    score: 20,
    industry: "Oil & Gas Services",
    province: "Namibe",
    updatedDate: "01 Sep 2026",
    updatedTime: "06:30 AM",
  },
];

export const FILTERS = [
  {
    key: "status",
    label: "Status",
    placeholder: "All Status",
    options: ["Active", "Inactive"],
  },
  {
    key: "risk",
    label: "Risk Level",
    placeholder: "All Risk Levels",
    options: ["Low", "Medium", "High"],
  },
  {
    key: "score",
    label: "Compliance Score",
    placeholder: "All Scores",
    options: ["80 - 100", "50 - 79", "0 - 49"],
  },
  {
    key: "industry",
    label: "Industry",
    placeholder: "All Industries",
    options: [
      "Manufacturing",
      "Trading",
      "Logistics",
      "Services",
      "Import/Export",
      "Construction",
      "Technology",
      "Food & Beverages",
      "Oil & Gas Services",
    ],
  },
  {
    key: "province",
    label: "Province",
    placeholder: "All Provinces",
    options: ["Luanda", "Bengo", "Huila", "Cabinda", "Namibe"],
  },
];

// Bounds for the "Compliance Score" filter, keyed by its option label.
export const SCORE_RANGES = {
  "80 - 100": [80, 100],
  "50 - 79": [50, 79],
  "0 - 49": [0, 49],
};

/* -------------------------------------------------------------- 360° view -- */

export const TAXPAYER_DETAIL = {
  nif: "100-123-456",
  name: "Blue Horizon Ltd.",
  status: "Active",
  score: 87,
  riskLevel: "Low",
  riskScore: 12,
  lastRiskReview: "01 Sep 2026",
  scoreCalculatedOn: "01 Sep 2026",

  summary: [
    { label: "NIF", value: "100-123-456" },
    { label: "Registration Date", value: "12 Jan 2018" },
    { label: "Taxpayer Type", value: "Company" },
    { label: "Tax Regime", value: "General" },
    { label: "Industry", value: "Manufacturing" },
  ],

  badges: [
    { label: "Compliant", tone: "good" },
    { label: "Verified", tone: "info" },
    { label: "e-Invoicing Enabled", tone: "info" },
    { label: "Filed Returns", tone: "good" },
  ],

  company: [
    { label: "Legal Name", value: "Blue Horizon Ltd." },
    { label: "Trade Name", value: "Blue Horizon Ltd." },
    { label: "NIF", value: "100-123-456" },
    { label: "Registration Number", value: "RC/LUA/2018/12345" },
    { label: "Industry", value: "Manufacturing" },
    { label: "Sub Industry", value: "Food Processing" },
    { label: "Company Size", value: "Medium" },
    { label: "Status", value: "Active", tone: "good" },
    { label: "Address", value: "Rua do Governo, Nº 123\nLuanda, Angola" },
    { label: "Phone", value: "+244 923 123 456" },
    { label: "Email", value: "info@bluehorizon.ao" },
    { label: "Website", value: "www.bluehorizon.ao" },
  ],

  scoreBreakdown: [
    { label: "Tax Filing", value: 90, icon: "filing" },
    { label: "Payments", value: 85, icon: "payments" },
    { label: "VAT Compliance", value: 88, icon: "vat" },
    { label: "Withholding Tax", value: 82, icon: "withholding" },
    { label: "Document Compliance", value: 80, icon: "documents" },
  ],

  connections: [
    { label: "DGI Master Record", sync: "2 min ago", icon: "building" },
    { label: "VAT System", sync: "5 min ago", icon: "receipt" },
    { label: "Customs", sync: "8 min ago", icon: "customs" },
    { label: "Business Registry", sync: "10 min ago", icon: "building" },
    { label: "Social Security", sync: "15 min ago", icon: "users" },
    { label: "Bank Data (Approved)", sync: "20 min ago", icon: "bank" },
  ],

  contacts: [
    {
      role: "Legal Representative",
      name: "John Smith",
      phone: "+244 923 111 222",
      email: "john.smith@bluehorizon.ao",
    },
    {
      role: "Tax Representative",
      name: "Maria Fernandes",
      phone: "+244 923 222 333",
      email: "maria.fernandes@bluehorizon.ao",
    },
    {
      role: "Accountant",
      name: "Paulo Costa",
      phone: "+244 923 333 444",
      email: "paulo.costa@bluehorizon.ao",
    },
  ],

  activity: [
    {
      title: "VAT return for Aug 2026 submitted",
      when: "01 Sep 2026, 10:45 AM",
      by: "System",
      done: true,
    },
    {
      title: "Payment received for Tax ID: 100-123-456",
      when: "01 Sep 2026, 09:32 AM",
      by: "Payments System",
      done: true,
    },
    {
      title: "Company information updated",
      when: "30 Aug 2026, 04:15 PM",
      by: "DGI Officer",
      done: false,
    },
  ],
};

export const DETAIL_TABS = [
  "Overview",
  "Company Details",
  "Tax Information",
  "Activities",
  "Connections",
  "Documents",
  "Risk Analysis",
  "Audit History",
  "Notes",
];
